import { Box, useTheme } from "@mui/material";
import React from "react";
import {
    Bar,
    BarChart,
    LabelList,
    ResponsiveContainer,
    XAxis,
    YAxis,
} from "recharts";
import TileBox from "../../../components/tile/TileBox";
import { useStyles } from "./styles";

const TopServicesReport = ({ data }) => {
  const classes = useStyles();
  const theme = useTheme();
  const { orange, blue, primary, purple, yellow } = theme.palette;
  const colors = [orange[1], blue[3], primary.main, purple[1], yellow[1]];
  const chartData = Object.keys(data?.top_services).map((key) => ({
    name: key.replace("-", " "),
    value: data?.top_services?.[key],
  }));

  const CustomBar = (props) => {
    const { x, y, width, height, index } = props;
    return (
      <g>
        <rect
          x={x}
          y={y}
          width={width}
          height={height}
          fill={colors[index % colors.length]}
        />
        <circle
          cx={x + width}
          cy={y + 1}
          r={5}
          fill={colors[index % colors.length]}
        />
      </g>
    );
  };

  return (
    <TileBox title="Top 5 Non-Terraform Managed Services">
      <Box height={"100% !important"} className={classes.root}>
        <Box height={"100%"} display={"flex"} justifyContent={"center"} mt={5}>
          <ResponsiveContainer
            width={"100%"}
            height={60 * chartData.length}
            debounce={50}
          >
            <BarChart
              data={chartData}
              layout="vertical"
              margin={{ left: 40, right: 30 }}
            >
              <XAxis type="number" tickLine={false} />
              <YAxis
                yAxisId={0}
                dataKey={"name"}
                type="category"
                tick={{
                  fontSize: 10,
                  fontWeight: 600,
                }}
                tickLine={false}
              />
              <Bar dataKey={"value"} barSize={3} shape={<CustomBar />}>
                <LabelList
                  fontSize={10}
                  fontWeight={600}
                  dataKey="value"
                  position="insideBottomRight"
                />
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </Box>
      </Box>
    </TileBox>
  );
};

export default TopServicesReport;
